import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'product',
    canActivate: [AuthGuard],
    data: { authorizedRole: 'instructor' },
    loadChildren: () =>
      import('./instructor/instructor.routes').then((m) => m.INSTRUCTOR_ROUTES),
  },
  {
    path: 'assignment',
    canActivate: [AuthGuard],
    data: { authorizedRole: 'learner' },
    loadChildren: () =>
      import('./learner/learner.routes').then((m) => m.LEARNER_ROUTES),
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('up').then((m) => m.UPUnauthorizedComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'assignment',
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/error/error.component').then(
        (m) => m.ErrorComponent,
      ),
  },
];
